export default {
      id: "sli-settings-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cf73de4e.svg#sli-settings",
      toString: function () {
        return this.url;
      }
    }